import { createRouter, createWebHashHistory } from 'vue-router';

const routes = [
  {
    name: 'notFound',
    path: '/:path(.*)+',
    redirect: {
      name: 'home',
    },
  },
  {
    name: 'login',
    path: '/login',
    component: () => import('./view/login'),
    meta: {
      title: '登录',
    },
  },
  {
    name: 'register',
    path: '/register',
    component: () => import('./view/login/register'),
    meta: {
      title: '注册',
    },
  },
  {
    name: 'accountRegister',
    path: '/account/register',
    component: () => import('./view/login/accountRegister'),
    meta: {
      title: '添加账号',
    },
  },
  {
    name: 'pass',
    path: '/pass',
    component: () => import('./view/login/pass'),
    meta: {
      title: '忘记密码',
    },
  },
  {
    name: 'home',
    path: '/home',
    component: () => import('./view/home'),
    meta: {
      title: '首页',
    },
  },
  {
    name: 'guys',
    path: '/guys',
    component: () => import('./view/guys'),
    meta: {
      title: '圈子',
      user_scalable: 'no'
    },
  },
  {
    name: 'my',
    path: '/my',
    component: () => import('./view/my'),
    meta: {
      title: '我的',
      user_scalable: 'no'
    },
  },
  {
    name: 'detail',
    path: '/my/detail',
    component: () => import('./view/my/detail'),
    meta: {
      title: '个人资料',
      user_scalable: 'no'
    },
  },
  {
    name: 'detailEdit',
    path: '/my/detailEdit',
    component: () => import('./view/my/detailEdit'),
    meta: {
      title: '资料编辑',
      user_scalable: 'no'
    },
  },
  {
    name: 'myguys',
    path: '/my/guys',
    component: () => import('./view/my/guys'),
    meta: {
      title: '我的圈子',
      user_scalable: 'no'
    },
  },
  {
    name: 'history',
    path: '/my/history',
    component: () => import('./view/my/history'),
    meta: {
      title: '结算历史',
      user_scalable: 'no'
    },
  },
  {
    name: 'accountdetail',
    path: '/my/accountdetail',
    component: () => import('./view/my/accountdetail'),
    meta: {
      title: '账号详情',
      user_scalable: 'no'
    },
  },
  {
    name: 'accountdetail',
    path: '/my/accountdetail',
    component: () => import('./view/my/accountdetail'),
    meta: {
      title: '账号详情',
      user_scalable: 'no'
    },
  },
  {
    name: 'bills',
    path: '/my/bills',
    component: () => import('./view/bills'),
    meta: {
      title: '我的流水',
      user_scalable: 'no'
    },
  },
];

const router = createRouter({
  routes,
  history: createWebHashHistory(),
});

router.beforeEach((to, from, next) => {
  document.body.scrollTop = 0;// firefox浏览器中是这句
  document.documentElement.scrollTop = 0;
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next();
});

export { router };
